import { CopyToClipboard, Icon, Label } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Stack, Tooltip, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PhoneNumberInfoProps as Props } from './types';

export const PhoneNumberInfo = memo(
  ({ className, number, title, status, isPrimary, isVerified }: Props) => {
    const hover = useBoolean(false);

    const handleMouseLeave = () => {
      hover.onFalse();
    };

    const handleMouseEnter = () => {
      hover.onTrue();
    };

    return (
      <Styled.Wrapper
        className={classnames('PhoneNumberInfo', className)}
        sx={SX.root}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Tooltip title={number ? 'Mobile Number' : undefined} placement="left">
          <Stack direction="row" justifyContent="space-between" width="100%">
            <Stack direction="row" gap={0.5} alignItems="center">
              <Icon
                name={isPrimary ? 'smartphone' : 'phone'}
                size={16}
                color="grey.500"
              />
              <Typography color="grey.700" variant="body3" fontWeight={400}>
                {number || title || 'No mobile phone number found!'}
              </Typography>
              {isPrimary && (
                <Label
                  variant="soft"
                  color="default"
                  size="xsmall"
                  title="Primary"
                  children="Primary"
                />
              )}
            </Stack>
            <Stack direction="row" gap={0.5} alignItems="center">
              {number && (
                <CopyToClipboard
                  value={number ?? ''}
                  icon={
                    <Icon
                      name="copy"
                      size={16}
                      color={(p) => p.palette.grey[500]}
                    />
                  }
                />
              )}
              {isVerified && (
                <Label
                  variant="soft"
                  color="success"
                  size="xsmall"
                  title="Verified"
                  children="Verified"
                />
              )}
              {status === 'Unknown' && (
                <Label
                  variant="soft"
                  color="default"
                  size="xsmall"
                  title="Unknown"
                  children="Unknown"
                />
              )}
            </Stack>
          </Stack>
        </Tooltip>
      </Styled.Wrapper>
    );
  }
);

PhoneNumberInfo.displayName = 'PhoneNumberInfo';
